import '../scss/wpjobs.scss';
import '../scss/splide-core.scss';
import '../scss/single-blog.scss';
import '../scss/homepage.scss';
import '../scss/gridbuilder.scss';
import '../scss/formidable.scss';
import '../scss/footer.scss';
import '../scss/custom.scss';
import '../scss/base.scss';
import '../react/buttons/style.scss';
import '../react/buttons/editor.scss';
import '../model-block/_model.scss';
import '../../blocks/slider-temoignages-unitex/slider-temoignages-unitex.scss';
import '../../blocks/slider-services-unitex/slider-services-unitex.scss';
import '../../blocks/numbers-horizontal-unitex/numbers-horizontal-unitex.scss';
import '../../blocks/number-damier-unitex/number-damier-unitex.scss';
import '../../blocks/mosaic-equipe-unitex/mosaic-equipe-unitex.scss';
import '../../blocks/menu-unitex/menu-unitex.scss';
import '../../blocks/list-partenaires-unitex/list-partenaires-unitex.scss';
import '../../blocks/list-icons-unitex/list-icons-unitex.scss';
import '../../blocks/last-blog-unitex/last-blog-unitex.scss';
import '../../blocks/iframe-unitex/iframe-unitex.scss';
import '../../blocks/hero-unitex/hero-unitex.scss';
import '../../blocks/hero-single-unitex/hero-single-unitex.scss';
import '../../blocks/grid-icons-unitex/grid-icons-unitex.scss';
import '../../blocks/grid-documentations-unitex/grid-documentations-unitex.scss';
import '../../blocks/footer-unitex/footer-unitex.scss';
import '../../blocks/featured-project-unitex/featured-project-unitex.scss';
import '../../blocks/damier-fil-unitex/damier-fil-unitex.scss';
import '../../blocks/cta-hidden-unitex/cta-hidden-unitex.scss';
import '../../blocks/checkerboard-unitex/checkerboard-unitex.scss';
import '../../blocks/checkerboard-dropdown-unitex/checkerboard-dropdown-unitex.scss';
import '../../blocks/bento-contact-unitex/bento-contact-unitex.scss';
import '../../blocks/archive-projets-unitex/archive-projets-unitex.scss';
import '../../blocks/archive-partenaires-unitex/archive-partenaires-unitex.scss';
import '../../blocks/archive-documentation/archive-documentation.scss';
import '../../blocks/archive-blog-unitex/archive-blog-unitex.scss';